import React from "react";

function HighLightText({ text, keyword, style }) {
  if (!keyword) return <p>{text}</p>;

  const regex = new RegExp(`(${keyword})`, "gi");
  const parts = text.split(regex);

  return (
    <p>
      {parts.map((part, i) =>
        regex.test(part) ? (
          <span key={i} style={style}>
            {part}
          </span>
        ) : (
          part
        )
      )}
    </p>
  );
}

export default HighLightText;

